import { Component } from 'react';
import { createRoot } from 'react-dom/client';
import Helper from "Interfaces/Helper";
import AudioItem from "./AudioPlayer.interface";
import { Audio } from './Audio'
import './AudioPlayer.scss'
import ComponentBackground from '../../GeneralComponents/ComponentBackground';
import ComponentHeader from '../../GeneralComponents/ComponentHeader';
import { BackColor } from "Interfaces/general.interface";
const API_URL = "/api/AudioPlayer";

class AudioPlayer extends Component {

    state:
        {
            error: boolean;
            isLoaded: boolean;
            componentId: string;
            title: string;
            description: string;
            backColor: string;
            componentQuery: string;
            currentPageId: number;
            items: AudioItem[];
            isActive: boolean;
            activePlayerId: string;
            lightBg: boolean;

        };
    props: any;


    constructor(props) {
        super(props);
        this.state = {
            error: false,
            isLoaded: false,
            componentId: this.props.id,
            title: this.props.title,
            description: this.props.description,
            componentQuery: this.props.query,
            backColor: this.props.backColor,
            currentPageId: this.props.currentPageId,
            items: [],
            isActive: false,
            activePlayerId: null,
            lightBg: true
        };

    }
    componentDidMount() {

        Helper.fetchData({ API_URL, queryId: this.state.componentQuery, pageId: this.state.currentPageId })
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result
                    });
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error: true
                    });
                }
            )
    }



    componentDidUpdate() {
    }

    render() {

        const { error, isLoaded, items } = this.state;
        const backGround: BackColor = this.props.backColor ? JSON.parse(this.props.backColor) : null;

        if (isLoaded && !error) {

            if (this.state.items.length == 0) {
                return (<div className="txt-invisible" > No return Items!!! </div>);
            }          

            if (this.state.items.length > 0) {            

                return (
                    <ComponentBackground
                        componentId={"AudioPlayer-" + this.state.componentId}
                        backGround={backGround}
                        setLightBg={(isLight) => this.setState({ lightBg: isLight })}>
                        <article dir={document.dir} className="pt-3 pb-3">
                            <div className="apl container">
                                <ComponentHeader
                                    disptitle={this.state.title}
                                    dispdescription={this.state.description}
                                    light={this.state.lightBg}
                                />
                                {items.map((item, index) => {
                                    return this.renderItem(item, index)
                                })}
                            </div>
                        </article>
                    </ComponentBackground>
                );
            }
        }
        return (null);
    }

    renderItem = (item, index) => {
        const playerId = `player-${this.state.componentId}${index + 1}`
        return (
            <section key={playerId} className="apl__section">
                <Audio
                    audioUrl={item.file}
                    title={item.title}
                    subtitle={item.description}
                    date={item.lastUpdateDate}
                    thumbnailUrl={item.image}
                    icon={item.icon}
                    itemId={item.id}
                    playerId={playerId}
                    isActive={this.state.activePlayerId === null || this.state.activePlayerId === playerId}
                    onPlay={() => this.setState({ activePlayerId: playerId })}
                />
            </section>
        )
    }
}

var elements = document.querySelectorAll('[id^="AudioPlayer-"]');

for (var i = 0; i < elements.length; i++) {

    var rootElement = document.getElementById(elements[i].id);
    var root = createRoot(rootElement);
    var audioPlayerId = rootElement.getAttribute('id').split('-')[1];

    root.render(
        <AudioPlayer
            id={audioPlayerId}
            currentPageId={rootElement.getAttribute('component-currentPageId')}
            title={rootElement.getAttribute('component-title')}
            description={rootElement.getAttribute('component-description')}
            query={rootElement.getAttribute('component-query')}
            backColor={rootElement.getAttribute('component-backColor')}
        />);

}